import { GetVmiLocationsApiParameter } from "@insite/client-framework/Services/VmiLocationService";

const staticFiles = "/staticContent";

export default {
    path: {
        userFiles: "/userfiles",
        staticFiles,
        fonts: `${staticFiles}/fonts`,
    },
    widgetGroup: {
        layout: "Layout" as any,
        styleguide: "Styleguide" as any,
        blogArticlePage: "Blog Article" as any,
        blogCategoryPage: "Blog Category" as any,
        blogHomePage: "Blog Home" as any,
        blog: "Blog" as any,
    },
    responseCode: {
        ok: "200",
        bad: "400",
        unauthorized: "401",
        forbidden: "403",
        notFound: "404",
        timeout: "408",
        unhandled: "500",
        unavailable: "503",
    },
    userRole: {
        administrator: "Administrator",
        buyer1: "Buyer1",
        buyer2: "Buyer2",
        buyer3: "Buyer3",
    },
    pageType: {
        accountSettings: "AccountSettingsPage",
        addresses: "AddressesPage",
        brandDetails: "BrandDetailsPage",
        brands: "BrandsPage",
        budgetManagement: "BudgetManagementPage",
        cart: "CartPage",
        cartReminderUnsubscribe: "CartReminderUnsubscribePage",
        categoryDetails: "CategoryDetailsPage",
        categoryList: "CategoryListPage",
        changeCustomer: "ChangeCustomerPage",
        changePassword: "ChangePasswordPage",
        checkoutReviewAndSubmit: "CheckoutReviewAndSubmitPage",
        checkoutShipping: "CheckoutShippingPage",
        createAccount: "CreateAccountPage",
        dealerDetails: "DealerDetailsPage",
        expiredAccountActivationLink: "ExpiredAccountActivationLinkPage",
        expiredResetPasswordLink: "ExpiredResetPasswordLinkPage",
        home: "HomePage",
        invoiceDetails: "InvoiceDetailsPage",
        invoiceHistory: "InvoiceHistoryPage",
        locationFinder: "LocationFinderPage",
        myAccount: "MyAccountPage",
        myListsDetails: "MyListsDetailsPage",
        myLists: "MyListsPage",
        newsList: "NewsListPage",
        news: "NewsPage",
        notFoundError: "NotFoundErrorPage",
        orderApprovalDetails: "OrderApprovalDetailsPage",
        orderApprovalList: "OrderApprovalListPage",
        orderConfirmation: "OrderConfirmationPage",
        orderDetails: "OrderDetailsPage",
        orderHistory: "OrderHistoryPage",
        orderStatus: "OrderStatusPage",
        orderUpload: "OrderUploadPage",
        productCompare: "ProductComparePage",
        productDetails: "ProductDetailsPage",
        productList: "ProductListPage",
        quickOrder: "QuickOrderPage",
        requestRma: "RequestRmaPage",
        requisitionConfirmation: "RequisitionConfirmationPage",
        requisitions: "RequisitionsPage",
        resetPassword: "ResetPasswordPage",
        rfqConfirmation: "RfqConfirmationPage",
        rfqJobQuoteDetails: "RfqJobQuoteDetailsPage",
        rfqJobQuotes: "RfqJobQuotesPage",
        rfqMyQuotes: "RfqMyQuotesPage",
        rfqQuoteDetails: "RfqQuoteDetailsPage",
        rfqRequestQuote: "RfqRequestQuotePage",
        robotsTxt: "RobotsTxtPage",
        savedOrderDetails: "SavedOrderDetailsPage",
        savedOrderList: "SavedOrderListPage",
        savedPayments: "SavedPaymentsPage",
        signIn: "SignInPage",
        staticList: "StaticListPage",
        unhandledError: "UnhandledErrorPage",
        userList: "UserListPage",
        userSetup: "UserSetupPage",
        vmiLocationDetails: "VmiLocationDetailsPage",
        vmiLocations: "VmiLocationsPage",
        vmiUsers: "VmiUsersPage",
        vmiDashboard: "VmiDashboardPage",
        vmiReporting: "VmiReportingPage",
        vmiBinDetails: "VmiBinDetailsPage",
        vmiBins: "VmiBinsPage",
        vmiOrderDetails: "VmiOrderDetailsPage",
        vmiOrderHistory: "VmiOrderHistoryPage",
        compactHeader: "CompactHeader",
        maintenance: "MaintenancePage",
        signInOverlay: "SignInOverlay",
        addressBookOverlay: "AddressBookOverlay",
        manifestJsonPage: "ManifestJsonPage",
        onePageCheckoutConfirmationPage: "OnePageCheckoutConfirmationPage",
        onePageCheckoutPage: "OnePageCheckoutPage",
        serviceWorkerJsPage: "ServiceWorkerJsPage",
        storePickupOverlay: "StorePickupOverlay",
        folder: "FolderPage",
        blogHomePage: "BlogHomePage",
        blogCategoryPage: "BlogCategoryPage",
        blogArticlePage: "BlogArticlePage",
        onePageCheckoutProductListOverlay: "OnePageCheckoutProductListOverlay",
        llmsTxtPage: "LlmsTxtPage",
    },
    productCompare: {
        maxNumberOfColumns: 4,
        carouselId: "product-compare-carousel-id",
    },
    listType: {
        all: "all",
        autogenerated: "autogenerated",
        favorites: "favorites",
        hidden: "hidden",
    },
    notesMaxCharacters: 300,
    searchDebounceDelay: 250,
    vmi: {
        metricFilter: {
            all: "allproducts",
            belowminimum: "belowminimum",
            fastmoving: "fastmoving",
            slowmoving: "slowmoving",
        },
        locationsApiParameters: {
            filter: "",
            sort: "Name",
            expand: ["customerlabel"],
            page: 1,
            pageSize: 9999,
        } as GetVmiLocationsApiParameter,
    },
    blog: {
        getDataViewType: {
            categoryArticles: "categoryArticles",
            featuredArticle: "featuredArticle",
            mostRecent: "mostRecent",
            similarArticles: "similarArticles",
        },
        getLocalizedDateTimeOptions: { year: "numeric", month: "long", day: "numeric" } as Intl.DateTimeFormatOptions,
    },
    contentSearch: {
        tabKey: {
            products: "products",
            contents: "contents",
        },
    },
    carouselType: {
        customProducts: "customProducts",
        purchasedProducts: "purchasedProducts",
    },
};
